'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var sdk = require('@cognite/sdk');
var sdkCore = require('@cognite/sdk-core');

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

var version="5.12.0";

// Copyright 2022 Cognite AS
var ChannelsAPI = /** @class */ (function (_super) {
    __extends(ChannelsAPI, _super);
    function ChannelsAPI() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.create = function (items) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.createEndpoint(items)];
            });
        }); };
        _this.list = function (filter) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.listEndpoint(this.callListEndpointWithPost, filter)];
            });
        }); };
        _this.update = function (changes) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.updateEndpoint(changes)];
            });
        }); };
        _this.delete = function (ids) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.deleteEndpoint(ids)];
            });
        }); };
        return _this;
    }
    return ChannelsAPI;
}(sdkCore.BaseResourceAPI));

// Copyright 2022 Cognite AS
var SubscribersAPI = /** @class */ (function (_super) {
    __extends(SubscribersAPI, _super);
    function SubscribersAPI() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.create = function (items) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.createEndpoint(items)];
            });
        }); };
        _this.list = function (filter) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.listEndpoint(this.callListEndpointWithPost, filter)];
            });
        }); };
        _this.delete = function (ids) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.deleteEndpoint(ids)];
            });
        }); };
        return _this;
    }
    return SubscribersAPI;
}(sdkCore.BaseResourceAPI));

// Copyright 2022 Cognite AS
var SubscriptionsAPI = /** @class */ (function (_super) {
    __extends(SubscriptionsAPI, _super);
    function SubscriptionsAPI() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.create = function (items) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.createEndpoint(items)];
            });
        }); };
        _this.delete = function (items) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.deleteEndpoint(items)];
            });
        }); };
        _this.list = function (filter) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.listEndpoint(this.callListEndpointWithPost, filter)];
            });
        }); };
        return _this;
    }
    return SubscriptionsAPI;
}(sdkCore.BaseResourceAPI));

// Copyright 2022 Cognite AS
var AlertsAPI = /** @class */ (function (_super) {
    __extends(AlertsAPI, _super);
    function AlertsAPI() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _this = _super.apply(this, __spread(args)) || this;
        _this.create = function (items) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.createEndpoint(items)];
            });
        }); };
        _this.list = function (query) {
            return _this.listEndpoint(_this.callListEndpointWithPost, query);
        };
        _this.close = function (items) { return __awaiter(_this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.post(this.url('close'), {
                            data: {
                                items: items,
                            },
                        })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, this.addToMapAndReturn(res.data, res)];
                }
            });
        }); };
        _this.listChannels = function (filter) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.channelsApi.list(filter)];
            });
        }); };
        _this.createChannels = function (items) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.channelsApi.create(items)];
            });
        }); };
        _this.deleteChannels = function (items) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.channelsApi.delete(items)];
            });
        }); };
        _this.updateChannels = function (items) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.channelsApi.update(items)];
            });
        }); };
        _this.createSubscribers = function (items) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.subscribersApi.create(items)];
            });
        }); };
        _this.listSubscribers = function (filter) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.subscribersApi.list(filter)];
            });
        }); };
        _this.deleteSubscribers = function (items) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.subscribersApi.delete(items)];
            });
        }); };
        _this.createSubscriptions = function (items) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.subscriptionsApi.create(items)];
            });
        }); };
        _this.listSubscriptions = function (filter) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.subscriptionsApi.list(filter)];
            });
        }); };
        _this.deleteSubscription = function (items) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.subscriptionsApi.delete(items)];
            });
        }); };
        var _a = __read(args, 3), resourcePath = _a[0], client = _a[1], metadataMap = _a[2];
        _this.channelsApi = new ChannelsAPI(resourcePath + "/channels", client, metadataMap);
        _this.subscribersApi = new SubscribersAPI(resourcePath + "/subscribers", client, metadataMap);
        _this.subscriptionsApi = new SubscriptionsAPI(resourcePath + "/subscriptions", client, metadataMap);
        return _this;
    }
    return AlertsAPI;
}(sdkCore.BaseResourceAPI));

var DataPointsAPI = /** @class */ (function (_super) {
    __extends(DataPointsAPI, _super);
    function DataPointsAPI() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.retrieve = function (query) {
            return _this.retrieveDatapointsEndpoint(query);
        };
        /**
         *
         * ```js
         * const monthlyAggregatesData = await client.datapoints.retrieveDatapointMonthlyAggregates({ items: [{ id: 123 }] });
         * ```
         */
        _this.retrieveDatapointMonthlyAggregates = function (query) { return __awaiter(_this, void 0, void 0, function () {
            var startDate, endDate, months, promises, results, mergedDatapoints, mergedTimeseries, results_1, results_1_1, result, result_1, result_1_1, item, resultSet, key, item;
            var e_1, _a, e_2, _b, _c;
            var _this = this;
            var _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        startDate = query.start;
                        endDate = query.end;
                        if (!(startDate && endDate)) return [3 /*break*/, 2];
                        months = this.getMonthsBetweenDates(startDate, endDate);
                        promises = months.map(function (month) {
                            // Create a new query for each month
                            var newQuery = __assign(__assign({}, query), { start: month.startDate, end: month.endDate, granularity: month.numberOfDays + "d" });
                            // Return a promise for each month
                            return _this.retrieveDatapointsEndpoint(newQuery);
                        });
                        return [4 /*yield*/, Promise.all(promises)];
                    case 1:
                        results = _e.sent();
                        mergedDatapoints = {};
                        mergedTimeseries = {};
                        try {
                            for (results_1 = __values(results), results_1_1 = results_1.next(); !results_1_1.done; results_1_1 = results_1.next()) {
                                result = results_1_1.value;
                                try {
                                    // There can be multiple time series in a response, so we need to loop through each item
                                    for (result_1 = (e_2 = void 0, __values(result)), result_1_1 = result_1.next(); !result_1_1.done; result_1_1 = result_1.next()) {
                                        item = result_1_1.value;
                                        if (!mergedTimeseries[item.id]) {
                                            mergedTimeseries[item.id] = item;
                                        }
                                        if ((_d = item === null || item === void 0 ? void 0 : item.datapoints) === null || _d === void 0 ? void 0 : _d.length) {
                                            if (!mergedDatapoints[item.id]) {
                                                mergedDatapoints[item.id] = item.datapoints;
                                            }
                                            else {
                                                (_c = mergedDatapoints[item.id]).push.apply(_c, __spread(item.datapoints));
                                            }
                                        }
                                    }
                                }
                                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                                finally {
                                    try {
                                        if (result_1_1 && !result_1_1.done && (_b = result_1.return)) _b.call(result_1);
                                    }
                                    finally { if (e_2) throw e_2.error; }
                                }
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (results_1_1 && !results_1_1.done && (_a = results_1.return)) _a.call(results_1);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        resultSet = [];
                        for (key in mergedTimeseries) {
                            item = mergedTimeseries[key];
                            if (key in mergedDatapoints) {
                                item.datapoints = mergedDatapoints[key];
                            }
                            else {
                                item.datapoints = [];
                            }
                            resultSet.push(item);
                        }
                        return [2 /*return*/, resultSet];
                    case 2: return [2 /*return*/, this.retrieveDatapointsEndpoint(query)];
                }
            });
        }); };
        return _this;
    }
    DataPointsAPI.prototype.retrieveDatapointsEndpoint = function (query) {
        return __awaiter(this, void 0, void 0, function () {
            var path, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        path = this.listPostUrl;
                        return [4 /*yield*/, this.post(path, {
                                data: query,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.addToMapAndReturn(response.data.items, response)];
                }
            });
        });
    };
    return DataPointsAPI;
}(sdk.DataPointsAPI));

// Copyright 2023 Cognite AS
var MonitoringTasksAPI = /** @class */ (function (_super) {
    __extends(MonitoringTasksAPI, _super);
    function MonitoringTasksAPI() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.create = function (items) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.createEndpoint(items)];
            });
        }); };
        _this.list = function (filter) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.listEndpoint(this.callListEndpointWithPost, filter)];
            });
        }); };
        _this.delete = function (ids) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.deleteEndpoint(ids)];
            });
        }); };
        _this.upsert = function (items) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.upsertEndpoint(items)];
            });
        }); };
        return _this;
    }
    return MonitoringTasksAPI;
}(sdkCore.BaseResourceAPI));

// Copyright 2020 Cognite AS
var CogniteClientCleaned = /** @class */ (function (_super) {
    __extends(CogniteClientCleaned, _super);
    function CogniteClientCleaned() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return CogniteClientCleaned;
}(sdk.CogniteClient));
/**
 * SDK client (beta)
 *
 * For smooth transition between stable sdk and beta, you may create an alias
 * `"@cognite/sdk": "@cognite/sdk-beta@^<version>"` in `package.json`
 * The beta SDK exports the client with the same name as stable, meaning you don't need to change any imports.
 * ```js
 * import { CogniteClient } from '@cognite/sdk';
 *
 * const client = new CogniteClient({ appId: 'YOUR APPLICATION NAME' });
 *
 * // can also specify a base URL
 * const client = new CogniteClient({ ..., baseUrl: 'https://greenfield.cognitedata.com' });
 * ```
 *
 * @param options Client options
 */
var CogniteClient = /** @class */ (function (_super) {
    __extends(CogniteClient, _super);
    function CogniteClient() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(CogniteClient.prototype, "alerts", {
        get: function () {
            return sdkCore.accessApi(this.alertsApi);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CogniteClient.prototype, "files", {
        get: function () {
            return sdkCore.accessApi(this.filesApi);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CogniteClient.prototype, "monitoringTasks", {
        get: function () {
            return sdkCore.accessApi(this.monitoringTasksApi);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CogniteClient.prototype, "datapoints", {
        get: function () {
            return sdkCore.accessApi(this.dataPointsApi);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CogniteClient.prototype, "version", {
        get: function () {
            return version + "-beta";
        },
        enumerable: false,
        configurable: true
    });
    CogniteClient.prototype.initAPIs = function () {
        _super.prototype.initAPIs.call(this);
        this.httpClient.setDefaultHeader('cdf-version', 'beta');
        this.alertsApi = this.apiFactory(AlertsAPI, 'alerts');
        this.monitoringTasksApi = this.apiFactory(MonitoringTasksAPI, 'monitoringtasks');
        this.dataPointsApi = this.apiFactory(DataPointsAPI, 'timeseries/data');
    };
    return CogniteClient;
}(CogniteClientCleaned));

// Copyright 2020 Cognite AS
var MonitoringTaskModelExternalId = {
    THRESHOLD: 'threshold',
    DOUBLE_THRESHOLD: 'double_threshold',
};
var AlertStatus = {
    FIRING: 'FIRING',
    PENDING: 'PENDING',
};
var AlertSortProperty = {
    CREATED_TIME: 'createdTime',
    LAST_TRIGGERED_TIME: 'lastTriggeredTime',
};

Object.keys(sdk).forEach(function (k) {
    if (k !== 'default') exports[k] = sdk[k];
});
exports.AlertSortProperty = AlertSortProperty;
exports.AlertStatus = AlertStatus;
exports.CogniteClient = CogniteClient;
exports.MonitoringTaskModelExternalId = MonitoringTaskModelExternalId;
//# sourceMappingURL=index.js.map
